import React, { ReactNode } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

type Props = {
  breadcrumbs: ReactNode[];
};

const BreadcrumbsContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isSmallScreen',
})<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
  width: 'calc(100% - 96px)',
  margin: 'auto',
  marginTop: theme.spacing(2),
  display: 'flex',
  gap: 6,
  flexWrap: 'wrap',

  '.breadcrumb': {
    fontSize: isSmallScreen ? '1.4rem' : '1.8rem',
    color: theme.palette.secondary.dark,
    background: 'transparent',
    padding: 0,
  },
}));

const renderBreadcrumbs = (breadcrumbs: ReactNode[]) =>
  breadcrumbs.reduce((acc: ReactNode[], item, index) => {
    const breadcrumb: ReactNode = (
      <Typography
        key={String(item)}
        className="breadcrumb"
        fontWeight={index === breadcrumbs.length - 1 ? 'bold' : undefined}
      >
        {item}
      </Typography>
    );

    const divider =
      index < breadcrumbs.length - 1 ? (
        <Typography key={`${item}:divider`} className="breadcrumb">
          {'//'}
        </Typography>
      ) : null;

    return [...acc, breadcrumb, divider];
  }, []);

const Breadcrumbs: React.FC<Props> = ({ breadcrumbs }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <BreadcrumbsContainer isSmallScreen={isSmallScreen}>
      {renderBreadcrumbs(breadcrumbs)}
    </BreadcrumbsContainer>
  );
};

export default Breadcrumbs;
